/*
 * @Author: amywulan
 * @Date: 2021-07-Fr 11: 44: 27
 * @Last Modified by: amywulan
 * @Last Modified time: 2021-07-Fr 11: 44: 27
 * @description 项目公参 http://wiki.intra.xiaojukeji.com/pages/viewpage.action?pageId=628231793
 */
import packageJSON from '../../../package.json'
import { getLocale, getLanguageLong } from '@/utils/locale'
import config from '@/config'
import qs from '@/utils/urlParam'
import { is_mobile, getNetworkType, getDevice } from '@/utils/os'
import env from '@/config/env'
import addressMonitor from '@/utils/addressMonitor'
import fingerprint from '@/utils/fingerprint'
import SparkMD5 from 'spark-md5'
import dPoi from '@/config/countryConfig/list/default-poi'
import { getCountry } from '@/utils/getLocalStorageCountry'
import { getSessionStorage } from '@/utils/sessionStorage'
import { SEO_CHANNEL, GOOGLE_MAP_CHANNEL } from '@/const/store'
const isH5 = document.body.clientWidth <= 768
import { SESSION_STORAGE_REFERER_POI } from '@/views/Store/constant.js'
import { getReferrerChannelType } from '@/utils/url-referrer-channel'


function generateRequestId(deviceId) {
  let timestamp = Math.floor(Date.now() / 1000)
  return SparkMD5.hash(timestamp + '' + deviceId).toUpperCase()
}
// StoreFont 方向不用默认地址
let defaultPoi = dPoi.getPoi(getCountry)

let isSF = qs('promotionChannel') === 'SF'
let cityId = defaultPoi?.cityId
let SFcityId = qs('cityId') || getSessionStorage('cityId')
const isFromSeo = [SEO_CHANNEL, GOOGLE_MAP_CHANNEL].includes(+qs('channel')) ? 1 : 0

if (isSF && SFcityId) {
  cityId = SFcityId
}

const isFromGoogleMap = +qs('channel') === 10

export function requestCommonParams() {
  addressMonitor?.flush()
  const lastPoi = addressMonitor?.get()

  const refererPoi = isFromGoogleMap ? getSessionStorage(SESSION_STORAGE_REFERER_POI) : {}


  return {
    /** @desc 公参不许加token **/

    /** @desc 地址信息 **/
    countyId: lastPoi?.countyId || defaultPoi.countyId,
    countyGroupId: lastPoi?.countyGroupId || defaultPoi.countyGroupId,
    cityId: lastPoi?.cityId || refererPoi?.cityId || cityId,
    lat: lastPoi?.lat || refererPoi?.lat || defaultPoi.lat,
    lng: lastPoi?.lng || refererPoi?.lng || defaultPoi.lng,
    poiId: lastPoi?.poiId || defaultPoi.poiId,

    /** @desc 地址未返回的参数 **/
    poiCityId: lastPoi?.poiCityId || lastPoi?.cityId || refererPoi?.cityId || defaultPoi?.cityId,
    poiCountyId: lastPoi?.poiCountyId || lastPoi?.countyId || defaultPoi.countyId,
    poiCountyGroupId:
      lastPoi?.poiCountyGroupId || lastPoi?.countyGroupId || defaultPoi.countyGroupId,
    poiName: lastPoi?.poiName || lastPoi?.displayName || defaultPoi.displayName,
    poiLat: lastPoi?.poiLat || lastPoi?.lat || refererPoi?.lat || defaultPoi.lat,
    poiLng: lastPoi?.poiLng || lastPoi?.lng || refererPoi?.lng || defaultPoi.lng,

    /** @desc 固定参数 **/
    appVersion: packageJSON.cApiVersion,
    versionCode: packageJSON.cApiVersion,
    clientType: 6,
    brand: env.is99 ? '3' : '2',
    timestamp: new Date().getTime(),
    dataType: isH5 ? 18 : 17, // 17 GLOBAL_PC; 18 GLOBAL_H5; 19 BR_PC; 20 BR_H5; 9 App
    terminalId: isH5 ? 300318 : 300308,

    locale: getLocale(),
    lang: getLanguageLong(),
    businessType: 'C',
    terminalType: '5',
    oid: config.omega.appKey,
    mapType: 'gmap',
    locationType: '-1',

    /** @desc 设备信息 **/
    osType: getDevice(),
    // https://developer.mozilla.org/zh-CN/docs/Web/API/Network_Information_API
    // 有兼容性，大部分获取不到
    networkType: getNetworkType(),
    wifiName: 'wifi', // todo
    osVersion: navigator.userAgent, // todo

    /** @desc 风控 **/
    suuid: fingerprint.get(), // todo
    imei: fingerprint.get(), // todo
    deviceId: fingerprint.get(), // todo
    deviceToken: fingerprint.get(), // todo
    requestId: generateRequestId(fingerprint.get()),

    /** @desc url上参数 **/
    enterChannel: qs('enterChannel'),
    extActivityId: qs('extActivityId'),
    promotionChannel: qs('promotionChannel'),
    fromSeo: isFromSeo,
    /** @desc 场景 **/
    scene: 1,
    utmSource: getReferrerChannelType(),
  }
}
